import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'digi-dialog-eror',
  templateUrl: './dialog-eror.component.html',
  styleUrl: './dialog-eror.component.scss'
})
export class DialogerrorComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogerrorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any // Dữ liệu được truyền vào dialog
  ) {}

  closeDialog(result: boolean): void {
    this.dialogRef.close(result); // Đóng dialog và trả về kết quả nếu cần
  }
}
